import { generatePath, type NavigateFunction, type Params } from 'react-router';
import type { Route } from '@debatdirect/common/types/route';
import { container } from '@debatdirect/common/src/modules/container';

export default class LegacyRouterService {
  navigateFn: NavigateFunction | undefined;
  currentParams: Params<string> = {};
  currentRoute: Route = { name: 'home', path: '/' };

  generate(name: string, params: Record<string, string> = {}) {
    const paths = container.get<Route[]>('routes');
    const foundRoute = paths.find((route) => route.name === name);

    if (!foundRoute) throw new Error(`Route ${name} not found in routes object`);

    return generatePath(foundRoute.path, params);
  }

  navigate(path: string) {
    if (!this.navigateFn) throw new Error('NavigateFn not defined in LegacyRouterService');
    return this.navigateFn(path);
  }

  replace(path: string) {
    if (!this.navigateFn) throw new Error('NavigateFn not defined in LegacyRouterService');
    return this.navigateFn(path, { replace: true });
  }

  goBackToIndex() {
    throw new Error('Not implemented');
  }

  setRouteAndParams(route: Route, params: Params<string>) {
    this.currentRoute = route;
    this.currentParams = params;
  }

  setNavigateFn(navigate: NavigateFunction) {
    this.navigateFn = navigate;
  }

  getRoute() {
    return this.currentRoute;
  }

  getParams() {
    return this.currentParams;
  }

  isEmbedded() {
    return this.currentRoute.name.includes('embedded');
  }

  getCurrentHttpHost() {
    throw new Error('Not implemented');
  }
}
